module.exports = __webpack_public_path__ + "static/media/narmena-life-co-funded-by-the-eu-vertical.0c591bea.png";